import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoTableBaseItemModel} from '../../../../tdo-controls/common/tdo-table/models/tdo-table-base-item.model';
import {ITdoTableItemModel} from '../../../../tdo-controls/common/tdo-table/interfaces/i-tdo-table-item.model';
import {TdoTableActionsEnum, TdoTableModel} from '../../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {MatSort} from '@angular/material/sort';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatSelectChange} from '@angular/material/select';
import {ToothService} from '../../../../services/tooth.service';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ValidValuesService} from '../../valid-values/valid-values.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ToothCanalConfigurationModel} from '../../../../models/configuration/tooth-canal-configuration.model';
import {ToothSurfaceConfigurationModel} from '../../../../models/teeth/tooth-surface-configuration.model';
import {Constants} from '../../../../constants';
import {ConfigurationService} from '../../configuration.service';

@Component({
  selector: 'app-teeth-canals-surfaces',
  templateUrl: './teeth-canals-surfaces.component.html',
  styleUrls: ['./teeth-canals-surfaces.component.scss']
})

export class TeethCanalsSurfacesComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('toothTable') toothTable: TdoTableV2Component;
  // @ViewChildren(TdoTableV2Component) tdoTables: QueryList<TdoTableV2Component>;
  @ViewChild('canalTable') canalTable: TdoTableV2Component;
  @ViewChild('surfaceTable') surfaceTable: TdoTableV2Component;


  // Table
  cfgTeeth: ToothConfigurationModel[];
  selectedTooth: ToothConfigurationModel;
  selectedToothCanalsToAdd: ToothCanalConfigurationModel[] = [];
  selectedToothSurfacesToAdd: ToothSurfaceConfigurationModel[] = [];
  enumCanals: EnumValidValueItemModel[] = [];
  enumSurfaces: EnumValidValueItemModel[] = [];

  numArraySelectedCanal: number[] = [];
  numArraySelectedSurface: number[] = [];

  isSavedCanals: boolean = false;
  isSavedSurfaces: boolean = false;

  saveDisabled: boolean = true;
  isEditing: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private toothService: ToothService,
    private validValueService: ValidValuesService,
    public configurationService: ConfigurationService
  ) { }

  ngOnInit(): void {

    // get teeth
    this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teethRes) => {
      this.cfgTeeth = teethRes;

      // this.cfgTeeth = this.cfgTeeth.sort((a, b) => Number(a.cfgToothDescriptions[0].Notation) - Number(b.cfgToothDescriptions[0].Notation));

      // select first tooth
      this.selectedTooth = this.cfgTeeth[0];
      this.setOrderArrays();

      // load tdo table
      // this.refreshTableViewData(this.cfgTeeth);
    }, err => {
      this.createMessage('Error loading teeth', 'Error');
    });

    // get enums
    this.validValueService.callGetenumValidValueItems('enumToothCanal').subscribe((canals) => {
      this.enumCanals = canals;
    }, err => {
      this.createMessage('Error loading canals', 'Error');
    });

    this.validValueService.callGetenumValidValueItems('enumToothSurface').subscribe((surfaces) => {
      this.enumSurfaces = surfaces;
    }, err => {
      this.createMessage('Error loading surfaces', 'Error');
    });
  }

  // Data change
  /*refreshTableViewData(models: ToothConfigurationModel[]) {
    this.cfgTeeth = models;

    this.tableViewData = Array.from(this.cfgTeeth, (_) => {
      const model = new TableViewData();
      model.notation = _.cfgToothDescriptions[0].Notation;
      model.isSelected = _.ToothId === this.selectedTooth.ToothId;
      model.model = _;
      return model;
    });
    this.dataSource = new MatTableDataSource(this.tableViewData);
    if (!this.tableModel) {
      this.tableModel = new TdoTableModel(this.displayedColumns, this.displayedColumnsLabels, this.dataSource, 'notation', 'asc');
      this.tableModel.searchPredicate = (data: TableViewData, filter: string) => {
        if (data.notation.toLowerCase().includes(filter)) {
          return true;
        }
      };
    }
  }*/

  setOrderArrays() {
    // canals
    let canalCount = 1;
    this.numArraySelectedCanal = [];
    this.selectedTooth.cfgToothCanals.forEach(a => {
      this.numArraySelectedCanal.push(canalCount++);
    });

    // surface
    let surfaceCount = 1;
    this.numArraySelectedSurface = [];
    this.selectedTooth.cfgToothSurfaces.forEach(a => {
      this.numArraySelectedSurface.push(surfaceCount++);
    });
  }

  onSave(event) {

    // reset saved vars
    this.isSavedCanals = false;
    this.isSavedSurfaces = false;

    // get items that need to be added to db
    const canalsToAdd: ToothCanalConfigurationModel[] = [];
    const surfacesToAdd: ToothSurfaceConfigurationModel[] = [];
    this.selectedTooth.cfgToothCanals.filter(a => a.isSaved === false).forEach(b => { canalsToAdd.push(b); });
    this.selectedTooth.cfgToothSurfaces.filter(a => a.isSaved === false).forEach(b => { surfacesToAdd.push(b); });

    // add canal to db
    this.toothService.addToothCanals(canalsToAdd).subscribe(add => {
      if (add) {
        // remove unsaved records
        if (add.length > 0) {
          this.selectedTooth.cfgToothCanals = this.selectedTooth.cfgToothCanals.filter(a => a.isSaved !== false);
        }

        // add newly added canals to model
        add.forEach(a => {
          a.isSaved = true;
          this.selectedTooth.cfgToothCanals.push(a);
        });

        // save canals to db
        this.toothService.saveToothCanals(this.selectedTooth.cfgToothCanals).subscribe(save => {
          if (save) {
            // save successful
            this.isSavedCanals = true;
            this.configurationService.setClean();
            this.updateTdoTables();
            this.onSaveCombined();
          }
        }, err => {
          this.createMessage('Error saving tooth canals', 'Error');
        });
      }
    }, err => {
      this.createMessage('Error adding canal', 'Error');
    });

    // add surfaces to db
    this.toothService.addToothSurfaces(surfacesToAdd).subscribe(add => {
      if (add) {
        // remove unsaved records
        if (add.length > 0) {
          this.selectedTooth.cfgToothSurfaces = this.selectedTooth.cfgToothSurfaces.filter(a => a.isSaved !== false);
        }
        // add newly added surfaces to model
        add.forEach(a => {
          a.isSaved = true;
          this.selectedTooth.cfgToothSurfaces.push(a);
        });

        // save surfaces to db
        this.toothService.saveToothSurfaces(this.selectedTooth.cfgToothSurfaces).subscribe(save => {
          if (save) {
            // save successful
            this.isSavedSurfaces = true;
            this.updateTdoTables();
            this.onSaveCombined();
          }
        }, err => {
          this.createMessage('Error saving tooth surfaces', 'Error');
        });
      }
    }, err => {
      this.createMessage('Error adding surface', 'Error');
    });
  }

  onSaveCombined() {
    if (this.isSavedSurfaces && this.isSavedCanals) {
      this.createMessage('Canals and surfaces saved', 'Success');
    }
  }

  onCancel(event) {
    this.saveDisabled = true;
    this.isEditing = false;

    this.selectedTooth.cfgToothSurfaces = this.selectedTooth.cfgToothSurfaces.filter(a => a.isSaved !== false);
    this.selectedTooth.cfgToothCanals = this.selectedTooth.cfgToothCanals.filter(a => a.isSaved !== false);

    this.setOrderArrays();
    this.updateTdoTables();
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectedTooth = event.row.model;
          this.updateTdoTables();
          return;
        } else {
          this.toothTable.selectionControl.select(this.selectedTooth);
        }
      });
    } else {
      this.selectedTooth = event.row.model;
      this.updateTdoTables();
    }
  }

  updateTdoTables() {
    // update canals and surfaces
    if (this.canalTable && this.surfaceTable) {
    this.canalTable.updateData(this.selectedTooth.cfgToothCanals);
    this.surfaceTable.updateData(this.selectedTooth.cfgToothSurfaces);
    }
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onTabChange($event: MatTabChangeEvent) {
    this.updateTdoTables();
  }

  addCanal() {
    const canal = new ToothCanalConfigurationModel();
    canal.ToothId = this.selectedTooth.ToothId;
    canal.CanalOrder = this.selectedTooth.cfgToothCanals.length + 1;
    canal.enumToothCanalID = Constants.emptyGuid;
    canal.isSaved = false;
    this.selectedTooth.cfgToothCanals.push(canal);
    this.setOrderArrays();
    this.updateTdoTables();
  }

  addSurface() {
    const surface = new ToothSurfaceConfigurationModel();
    surface.ToothId = this.selectedTooth.ToothId;
    surface.SegmentOrder = this.selectedTooth.cfgToothSurfaces.length + 1;
    surface.enumToothSurfaceID = Constants.emptyGuid;
    surface.isSaved = false;
    this.selectedTooth.cfgToothSurfaces.push(surface);
    this.setOrderArrays();
    this.updateTdoTables();
  }

  returnCanalName(id: string) {
    let strReturn: string = '';
    if (this.enumCanals) {
      strReturn = this.enumCanals.find(a => a.ValidValueItemId === id).ItemDisplayValue;
    }
    return strReturn;
  }

  returnSurfaceName(id: string) {
    let strReturn: string = '';
    if (this.enumSurfaces) {
      strReturn = this.enumSurfaces.find(a => a.ValidValueItemId === id).ItemDisplayValue;
    }
    return strReturn;
  }

  onRowSelectedCanal($event: TdoTableSelectionEvent) {

  }

  onRowSelectedSurface($event: TdoTableSelectionEvent) {

  }

  removeCanal(ToothCanalId: string) {
    // remove from model
    const canal = this.selectedTooth.cfgToothCanals.filter(a => a.isDelete === true);
    if (canal.length > 0) {
      canal[0].xauditDeleted = true;
    }

    this.selectedTooth.cfgToothCanals = this.selectedTooth.cfgToothCanals.filter(a => a.isDelete !== true);
    this.setOrderArrays();
    this.updateTdoTables();

    // if exists in db
    if (ToothCanalId) {
      // mark deleted in db
      this.toothService.saveToothCanals(canal).subscribe(save => {
        if (save) {
          // save successful
          this.createMessage('Canal removed', 'Success');
        }
      }, err => {
        this.createMessage('Error removing tooth surface', 'Error');
      });
    }
  }

  removeSurface(ToothSurfaceId: string) {
    // remove from model
    const surface = this.selectedTooth.cfgToothSurfaces.filter(a => a.isDelete === true);
    if (surface.length > 0) {
      surface[0].xauditDeleted = true;
    }

    this.selectedTooth.cfgToothSurfaces = this.selectedTooth.cfgToothSurfaces.filter(a => a.isDelete !== true);
    this.setOrderArrays();
    this.updateTdoTables();

    // if exists in db
    if (ToothSurfaceId) {
      // mark deleted in db
      this.toothService.saveToothSurfaces(surface).subscribe(save => {
        if (save) {
          // save successful
          this.createMessage('Surface removed', 'Success');
        }
      }, err => {
        this.createMessage('Error removing tooth surface', 'Error');
      });
    }
  }

  getToothNum(ToothId: string) {
    const t = this.cfgTeeth.find(p => p.ToothId === ToothId);
    if (t) {
      return t.cfgToothDescriptions[0].Notation;
    } else {
      return '';
    }
  }

  onChangeCanal($event: MatSelectChange) {

  }

  onChangeSurface($event: MatSelectChange) {

  }

  onChangeCanalOrder($event: MatSelectChange) {

  }

  onChangeSurfaceOrder($event: MatSelectChange) {

  }
}

// onChangeClient(event: MatSelectChange) {
//   this.isBusy = true;
//
//   this.feeDiscountService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
//     this.locationList = ldata;
//     this.selectedLocation = null;
//
//     if (this.locationList.length > 0) {
//       this.selectedLocation = this.locationList[0];
//       this.loadDiscountsForDoctorLocation();
//     }
//     this.isBusy = false;
//   }, err => {
//     console.log(err);
//     this.isBusy = false;
//   });
// }

// onChangeLoc(event) {
//   // location changed
//   this.selectedLocation = event.value;
//   this.loadDiscountsForDoctorLocation();
// }
